// convert a url to relative
import parser from 'url-parse'

export const parseUrl = url => parser(url)

export const relativeUrl = url => `/${url.replace(/^(?:\/\/|[^\/]+)*\//, '')}`

export const removeProtocol = (url, pretty = false) => `${pretty ? '' : '//'}${url.replace(/.*?:\/\//g, '')}`

export const addProtocol = (url, type = 'http') => (url.match(/^(http|https):\/\//) ? url : `${type}://${url}`)

export const getFavicon = url => {
    return `https://www.google.com/s2/favicons?domain=${url}`
}

export const getSlug = url => {
    const trimmed = url.replace(/\/$/, '')
    const bits = trimmed.split('/')
    return bits[bits.length - 1]
}

export const getGifId = url => {
    const isFile =
        url
            .split('/')
            .pop()
            .indexOf('.') > -1
    const slashes = url.split('/')
    const gifId = isFile
        ? slashes[slashes.length - 2]
        : slashes
              .pop()
              .split('-')
              .pop()

    return gifId || ''
}

export default {
    relativeUrl,
    removeProtocol,
    addProtocol,
    getGifId,
}
